export default {
  "movie.editMovie": "作品編集",
  "movie.createMovie": "作品作成",
  "movie.createEditMovie": "作品作成・編集",
  "movie.plsEnterMovieName": "作品名を入力してください",
  "movie.movieLength": "上映時間（分）",
  "movie.plsEnterMovieLength": "上映時間（分）を入力してください",
  "movie.movieTrailerLength": "予告上映時間（分）",
  "movie.plsEnterMovieTrailerLength": "予告上映時間（分）を入力してください",
  "movie.releaseDate": "公開日",
  "movie.plsSelectReleaseDate": "公開日を選択してください",
  "movie.plsEnterReleaseDate": "公開日を入力してください",
  "movie.workRemarks": "作品備考（「作品名【作品備考】」として表示）",
  "movie.plsEnterWorkRemarks": "作品備考を入力してください",
  "movie.id": "作品ID（劇場管理用）",
  "movie.plsEnterID": "作品ID（劇場管理用）を入力してください",
  "movie.infoAboutFile": "その他作品情報",
  "movie.genre": "ジャンル",
  "movie.plsEnterGenre": "作品のジャンルを選択してください",
  "movie.countryOfManufacture": "制作国",
  "movie.plsEnterCountryOfManufacture": "制作国を選択してください",
  "movie.director": "監督",
  "movie.plsEnterDirector": "監督を入力してください",
  "movie.actor": "出演",
  "movie.plsEnterActor": "出演を入力してください",
  "movie.filmSynopsis": "作品紹介",
  "movie.plsEnterfilmSynopsis": "作品紹介を入力してください",
  "movie.classify": "映倫",
  "movie.plsSelectClassify": "映倫を選択してください",
  "movie.copyright": "コピーライト",
  "movie.plsEnterCopyright": "コピーライトを入力してください",
  "movie.distribution": "配給",
  "movie.plsEnterDistribution": "配給会社を選択してください",
  "movie.officialWebsite": "公式サイト（URL）",
  "movie.plsEnterOfficialWebsite": "公式サイト（URL）を入力してください",
  "movie.coverAndTrailer": "画像と予告編",
  "movie.cover": "ポスター画像",
  "movie.picture": "スチール写真",
  "movie.plsUploadPic": "スチール写真をアップロードしてください",
  "movie.movieTrailer": "予告編（URL）",
  "movie.plsEnterMovieTrailer": "予告編リンクを入力してください",
  "movie.other": "販売設定",
  "movie.undisplayControl": "非表示設定",
  "movie.openStartingDay": "公開週起点日",
  "movie.plsSelectOpenStartingDay": "公開週起点日を選択してください",
  "movie.sorting": "表示順番",
  "movie.sorting2": "表示順番（CMS/オンライン予約）",
  "movie.plsUploadCover": "ポスター画像をアップロードしてください",
  "movie.uploadError": "アップロード失敗",
  "movie.searchName": "名前 / 作品IDを検索",
  "movie.deleteSchedule": "スケジュールを削除",
  "movie.sortByTime": "作成日時順",
  "movie.filmRate": "フィルム料歩率",
  "movie.startingDay": "対象期間（始日）",
  "movie.endingDay": "対象期間（終日）",
  "movie.mainBusiness": "本興行",
  "movie.morningShow": "モーニングショー",
  "movie.lateShow": "レイトショー",
  "movie.allNight": "オールナイト",
  "movie.specialBusiness": "特別興行",
  "movie.sureToCreate": "を作成してもよろしいですか?",
  "movie.NotSpecified": "指定されていない",
  "movie.movieLand": "（映画ランド）",
  "movie.flat": "フラット",
  "movie.circle": "円",
  "movie.release.type1": "日付入力",
  "movie.release.type2": "テキスト入力",
  "movie.release.type3": "公開日未定",
  "movie.plsSelectReleseDateType": "公開日時の種類を選択してください",
  "movie.originalName": "原題",
  "movie.plsEnterOriginalName": "原題を入力してください",
  "movie.hpDisplay": "HP表示",
  "movie.hpRelease": "HP公開",
  "movie.commonTicket": "全国共通券",
  "movie.ticket.common": "ムビチケ（システム連携専用）",
  "movie.ticket.other": "その他全国共通券",
  "movie.resetDays4Week": "公開週のリセット日数",
  "movie.plsEnterResetDays4Week": "公開週のリセット日数を入力してください",
  "movie.writers": "脚本",
  "movie.plsEnterWriters": "脚本を入力してください",
  "movie.credit": "詳細（クレジット）",
  "movie.plsEnterCredit": "詳細（クレジット）を入力してください",
  "movie.productionYear": "公開年",
  "movie.plsEnterProductionYear": "公開年を入力してください",
  "movie.codeOfMulberry": "券種コード",
  "movie.numOfUsers": "利用人数",
  "movie.nationwideUniversalTicket": "利用する",
  "movie.coordination": "調整動員",
  "movie.specialTicket": "専用券（スクリーン規格）",
  "movie.ticketList.ph.1": "券名を入力してください",
  "movie.ticketList.ph.2": "取引先を選択してください",
  "movie.ticketList.ph.3": "（例）1",
  "movie.ticketList.ph.4": "（例）1,350",
  "movie.ticketList.ph.5": "（例）1,500",
  "movie.ticketList.ph.6": "（例）150",
  "movie.ticketList.ph.7": "（例）01",
  "movie.ticketList.ph.8": "（例）1",
  "movie.ticketMaster.sellAmount": "販売金額",
  "movie.ticketMaster.glassesFee": "メガネ代",
  "movie.ticketMaster.listOfTickets": "券種リスト",
  "movie.openStr": "公開順",
  "movie.sortOf": "表示順番順",
  "movie.sortById": "作品ID（劇場管理用）順",
  "movie.approveTrue": "承認済",
  "movie.approveFalse": "未承認",
  "movie.synopsisTitle": "ストーリータイトル",
  "movie.synopsisTitlePlsInput": "ストーリータイトルを入力してください",
  "movie.synopsis": "ストーリー",
  "movie.profileTitle": "プロフィールタイトル",
  "movie.profileTitlePlsInput": "プロフィールタイトルを入力してください",
  "movie.profile": "プロフィール",
  "movie.slogan": "キャッチコピー",
  "movie.sloganPlsInput": "キャッチコピーを入力してください",
  "movie.display.picture": "ポスタープレビューリスト",
  "movie.display.list": "文字リスト",
  "movie.mvtk.category": "ムビチケ連携区分",
};